<template lang="pug">
div(
  v-if="isAuthenticated && !isHidden"
  :class=`[
    'header-wrap',
    'fixed',
    'top-0',
    'right-0',
    'z-index-10',
    'redesignControlsBackground',
    'pa-3',
    'rounded-b-xl',
    'd-flex',
    'flex-column',
    'user-select-none',
    {
      'mt-5 mr-10': $vuetify.breakpoint.smAndUp,
      'mt-0': !$vuetify.breakpoint.smAndUp,
    },
  ]`
  @mouseenter="switchMenu(true)"
  @mouseleave="switchMenu(false)"
)
  .d-flex.gap-16.align-center.pointer.justify-space-between(
    @click="switchMenu()"
  )
    tooltip-wrap(
      :value="username.length > MAX_NAME_LENGTH"
      left
      content-class="redesign redesignControlsBackground redesign-box-shadow rounded-8 opacity-100"
    )
      template(#reason)
        p.redesignPrimaryDarken--text {{ username }}
      p {{ username | cropName }}

    v-btn.px-0.no-before(
      small
      text
      exact
      exact-active-class="redesignPrimaryDarken--text"
      to="/notification"
      min-width="20px"
      :ripple="false"
      @click.stop
    )
      .d-flex.justify-start.full-width.gap-4.align-center
        v-icon(size="21") {{ notificationsCount ? '$ibell-outline-active' : '$ibell-outline' }}

    v-avatar.text-uppercase.font-weight-bold(
      color="#7f7c9f"
      size="34"
    )
      v-img(
        v-if="$user.profile && $user.profile.avatar"
        :src="$user.profile.avatar.thumb"
      )
      .white--text(v-else) {{ usernameSymbol }}
  v-expand-transition
    .d-flex.flex-column.gap-8(
      v-if="showUserMenu"
    )
      v-btn.px-0.no-before.flex-1.py-1(
        v-for="(button, idx) in manageButtons"
        :key="idx"
        small
        text
        exact
        exact-active-class="redesignPrimaryDarken--text"
        :to="button.to"
        :ripple="false"
        :class="{ 'mt-2': idx === 0 }"
      )
        .d-flex.justify-start.full-width.gap-4.align-center
          v-icon(size="20") {{ button.icon }}
          p.body-2 {{ button.text }}
      v-divider
      v-btn.px-0.no-before.flex-1.redesignError--text.pt-1(
        small
        text
        :ripple="false"
        @click="confirmLogOut"
      )
        .d-flex.justify-start.full-width.gap-4.align-center
          v-icon(size="20") $iexit
          p.body-2 Выйти
</template>

<script>
import LogoutIcon from '../icons/LogoutIcon.vue';
import { mapGetters } from 'vuex';
import ExpandMenu from '@/components/user-redesign/ExpandMenu.vue';

const MAX_NAME_LENGTH = 15;

export default {
  name: 'TheHeader',
  constants: {
    MAX_NAME_LENGTH,
  },
  components: {
    ExpandMenu,
    LogoutIcon,
  },
  filters: {
    cropName(v) {
      return v.length > MAX_NAME_LENGTH ? `${v.slice(0, MAX_NAME_LENGTH)}...` : v;
    },
  },
  data() {
    return {
      show: this.$header,
      MAX_NAME_LENGTH,
      showUserMenu: false,
    };
  },
  computed: {
    ...mapGetters({
      notificationsCount: 'notification/total',
    }),
    username() {
      const { ROLES } = this.$conf;
      if (this.$user.hasRoles([ROLES.organization])) {
        return this.$user.data.organizer.full_name;
      }

      if (this.$user.hasRoles([ROLES.operator])) {
        return this.$user.data.region.name;
      }

      if (this.$user.hasRoles([ROLES.department])) {
        return this.$user.data.department.name;
      }

      if (this.$user.hasRoles([ROLES.member, ROLES.trainer, ROLES.expert, ROLES.certificate, ROLES.event_manager])) {
        const firstName = this.$user.profile.first_name ? `${this.$user.profile.first_name.slice(0, 1)}.` : '';
        const lastName = this.$user.profile.last_name || '';
        const middleName = this.$user.profile.middle_name ? `${this.$user.profile.middle_name.slice(0, 1)}.` : '';
        if (!firstName || !lastName) {
          return this.$user.data.username;
        }

        return [lastName, firstName, middleName].join(' ');
      }

      return this.$user.data.username;
    },
    usernameSymbol() {
      const [firstLetter] = this.username;
      return firstLetter || 'U';
    },
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
    }),

    isHidden() {
      const { name } = this.$route;
      const { ROLES } = this.$conf;
      return [
        'ui-event-landing',
        'event-dashboard-main',
        'redesign-event-create',
        'PollPassingQuestions',
        'PollPassing',
        ...(this.$user.hasRoles([ROLES.member, ROLES.certificate]) ? ['PollViewQuestions'] : []),
      ].includes(name);
    },
    manageButtons() {
      const { ROLES } = this.$conf;
      const { isExpert } = this.$user;

      return [
        {
          hidden: !this.$user.hasRoles([ROLES.organization, ROLES.expert, ROLES.certificate, ROLES.event_manager]),
          icon: '$iuser',
          to: `${isExpert ? '/redesign' : ''}/my-profile`,
          text: 'Профиль',
        },
        {
          icon: '$iinfo',
          to: '/instructions',
          text: 'Инструкции',
        },
      ].filter((button) => !button.hidden);
    },
  },

  watch: {
    isAuthenticated() {
      this.switchMenu(false);
    },
  },

  methods: {
    switchMenu(value = null) {
      this.showUserMenu = value ?? !this.showUserMenu;
    },
    confirmLogOut() {
      this.$dialogs.confirm({
        attrs: {
          method: () => this.logout(),
          isRequest: false,
          message: 'Вы уверены, что хотите выйти из учётной записи?',
          closeBtnAttrs: {
            'btn-text': 'Остаться',
          },
          confirmBtnAttrs: {
            'btn-text': 'Выйти',
          },
        },
      });
    },
    async logout() {
      await this.$store.dispatch('auth/logout');
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss" scoped>
.header-wrap {
  box-shadow: 0px 1px 1px rgba(41, 41, 47, 0.16) !important;
}
</style>
